import { render, staticRenderFns } from "./FormularioOpcionalAssinaturaEletronica.vue?vue&type=template&id=99bf5f64&scoped=true"
import script from "./FormularioOpcionalAssinaturaEletronica.vue?vue&type=script&lang=js"
export * from "./FormularioOpcionalAssinaturaEletronica.vue?vue&type=script&lang=js"
import style0 from "./FormularioOpcionalAssinaturaEletronica.vue?vue&type=style&index=0&id=99bf5f64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99bf5f64",
  null
  
)

export default component.exports